<div class="flex gap-2 align-items-center">
  @if (icon || item.icon) {
    <i [class]="icon || item.icon"></i>
  }
  <span [ngClass]="{ 'font-bold': item.help }">{{ item.label }}</span>
  @if (item.suffix) {
    <code class="ml-auto flex gap-2 align-items-center font-bold">
      @if (item.suffixIcon) {
        <i [class]="item.suffixIcon"></i>
      }

      {{ item.suffix }}
    </code>
  } @else if (item.suffixIcon) {
    <i [class]="item.suffixIcon"></i>
  }
</div>
@if (item.help) {
  <div class="text-sm text-color-secondary">{{ item.help }}</div>
}
